import { formatNumber } from "./formatNumber";

export function formatCurrency(input, currency = 'ETH', decimals = 3, addSymbol = true) {
  if (currency === 'ETH') {
    return `${addSymbol ? 'Ξ ' : ''}${formatNumber(input, decimals)}`
  }

  if (currency === 'SOL') {
    return `${addSymbol ? '◎ ' : ''}${formatNumber(input, decimals)}`
  }

  return formatNumber(input, decimals);
}